import getChoiceGroupSelection from '../utils/getChoiceGroupSelection';
import getForwardingEmailAddress from '../utils/getForwardingEmailAddress';
import getKeepCopy from '../utils/getKeepCopy';
import { saveMailboxForwardingConfiguration } from 'owa-forwarding-configuration';
import MailboxOptions from 'owa-service/lib/contract/MailboxOptions';
import { action } from 'satcheljs/lib/legacy';

export default action('saveForwardingOption')(async function saveForwardingOption() {
    const isForwardingEnabled = getChoiceGroupSelection() === 'start';
    const forwardingEmailAddress = isForwardingEnabled ? getForwardingEmailAddress() : null;
    const keepCopy = getKeepCopy();

    const mailboxOptions: MailboxOptions = {
        AddressString: forwardingEmailAddress,
        DeliverToMailboxAndForward: keepCopy,
    };

    await saveMailboxForwardingConfiguration(mailboxOptions);
});
